import { createBaseFeed } from "../../factory/core/createBaseFeed.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-elements-library";
import "@universityofmaryland/web-elements-library/composite";
import "@universityofmaryland/web-elements-library/atomic";
import "@universityofmaryland/web-utilities-library/elements";
import { inTheNewsDisplayStrategy } from "../../strategies/display/inTheNews.js";
import "@universityofmaryland/web-utilities-library/network";
import "../../strategies/fetch/events.js";
import "../../strategies/fetch/news.js";
import "../../strategies/fetch/experts.js";
import { inTheNewsFetchStrategy } from "../../strategies/fetch/inTheNews.js";
import { stackedLayout } from "../../strategies/layout/grid.js";
import "@universityofmaryland/web-elements-library/layout";
const inTheNewsList = (props) => createBaseFeed({
  ...props,
  cardType: "list",
  isAligned: false,
  fetchStrategy: inTheNewsFetchStrategy,
  displayStrategy: inTheNewsDisplayStrategy,
  layoutStrategy: stackedLayout
});
export {
  inTheNewsList
};
//# sourceMappingURL=list.js.map
